import { createFileRoute, useParams } from "@tanstack/react-router";
import { VendorDetailPage } from "@/components/inventory/VendorDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/vendors_/$id")({
  component: AdminVendorDetail,
});

function AdminVendorDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/vendors_/$id" });
  return <VendorDetailPage vendorId={id} />;
}
